import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, DemoGym } from 'types';
import { client } from 'utils/api-client';

export default function useReactivateDemoGym(): UseMutationResult<
  AxiosResponse<DemoGym>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const mutationFn = (demoGymId: string): Promise<AxiosResponse<DemoGym>> => {
    return client.post(`demo-gyms/${demoGymId}/reactivate/`);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['demoGyms'],
      });
    },
  });
}
